const getGenericMinEqualToMax = (min?: number, max?: number) => {
  return min === max;
};

export default getGenericMinEqualToMax;
